module.exports = vendor_7ba712b40ab14c215732;